import { render, staticRenderFns } from "./select-tabs.vue?vue&type=template&id=638f6ef6&"
import script from "./select-tabs.ts?vue&type=script&lang=ts&"
export * from "./select-tabs.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports